import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';

import {
    requestLoadAppliedFertilizerEntitiesByDate,
    canceledLoadAppliedFertilizerEntitiesByDate
} from 'services/appliedFertilizerEntitiesByDate/actions';
import { AppliedFertilizerEntitiesByDateRequestProps } from 'services/appliedFertilizerEntitiesByDate/types';

interface OwnProps {
    namespace: string;
}

interface DispatchProps {
    requestLoadAppliedFertilizerEntitiesByDate: typeof requestLoadAppliedFertilizerEntitiesByDate;
    canceledLoadAppliedFertilizerEntitiesByDate: typeof canceledLoadAppliedFertilizerEntitiesByDate;
}

type Props = OwnProps &
    AppliedFertilizerEntitiesByDateRequestProps &
    DispatchProps;

export class AppliedEntitiesByDateRequestComponent extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { props } = this;

        if (props.startDate) {
            props.requestLoadAppliedFertilizerEntitiesByDate(props.startDate);
        }
    }

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;
        if (!isEqual(prevProps.startDate, props.startDate) && props.startDate) {
            props.requestLoadAppliedFertilizerEntitiesByDate(props.startDate);
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.canceledLoadAppliedFertilizerEntitiesByDate();
    }

    render(): null {
        return null;
    }
}

export default connect(null, {
    requestLoadAppliedFertilizerEntitiesByDate,
    canceledLoadAppliedFertilizerEntitiesByDate
})(AppliedEntitiesByDateRequestComponent);
